import { each, map, size, sumBy } from 'lodash';
import { E_Tristate } from '../types';
// bo服务常用分页函数
export function makePaginationDataFactory(wrapper, res) {
    if (res) {
        return {
            ...res,
            aaData: map(res.aaData, wrapper),
        };
    }
    else {
        return {
            s_echo: '',
            iDisplayLength: 0,
            iDisplayStart: 0,
            iTotalDisplayRecords: 0,
            iTotalRecords: 0,
            aaData: [],
        };
    }
}
export function makeNormalPaginationData(x) {
    return makePaginationDataFactory(item => item, x);
}
export function makeSelectablePaginationData(x) {
    return makePaginationDataFactory(item => {
        return {
            ...item,
            checked: false,
        };
    }, x);
}
export function markAllSelect(pageData, selected) {
    each(pageData.aaData, data => {
        data.checked = selected;
    });
}
export function selectedState(data) {
    const len = size(data);
    const selected = sumBy(data, item => item.checked ? 1 : 0);
    if (selected === 0) {
        return E_Tristate.Unselect;
    }
    else if (selected === len) {
        return E_Tristate.Selected;
    }
    else {
        return E_Tristate.Indeterminate;
    }
}
/**
 * 串行获取所有的分页数据
 */
export async function boPaginationLoadAll(buildQueryTask) {
    let res = [];
    const pageParams = {
        sEcho: 1,
        iDisplayLength: 10,
    };
    do {
        const responseData = await buildQueryTask(pageParams);
        const { aaData, iDisplayLength, iTotalRecords, } = responseData;
        res = [...res, ...aaData];
        if ((pageParams.sEcho) * iDisplayLength >= iTotalRecords) {
            break;
        }
        pageParams.sEcho += 1;
    } while (true);
    return res;
}
